module.exports = __webpack_public_path__ + "img/img16.51d0b563.png";